// W2CM v1–v3: little endian, fixed 1/8192-degree coordinates, zigzag deltas and varints.
export const CONNECTORS = ['Type 2', 'CCS', 'CHAdeMO', 'Type 1', 'CCS1', 'Type 3C', 'Schuko', 'MCS'];
const alphabet = '0123456789ABCDEFGHJKMNPQRSTVWXYZ';
export function code(n) {
  let out = '';
  do { out = alphabet[n % 32] + out; n = Math.floor(n / 32); } while (n);
  return out.padStart(4, '0');
}
export function kw(b) { return b <= 200 ? b : b === 255 ? 750 : 200 + (b - 200) * 10; }
export function decode(buffer) {
  const bytes = new Uint8Array(buffer), view = new DataView(buffer);
  if (bytes.length < 9 || String.fromCharCode(...bytes.slice(0, 4)) !== 'W2CM' || ![1, 2, 3].includes(bytes[4]))
    throw new Error('unknown map format');
  const count = view.getUint32(5, true);
  if (count > (bytes.length - 9) / 6) throw new Error('incomplete map catalog');
  const version = bytes[4] >= 2 ? [...bytes.slice(9, 17)].map(b => b.toString(16).padStart(2, '0')).join('') : null;
  let pos = bytes[4] >= 2 ? 17 : 9, x = 0, y = 0, index = 0;
  function read() {
    let value = 0, factor = 1;
    for (let i = 0; i < 6; i++) {
      if (pos >= bytes.length) throw new Error('incomplete coordinate');
      const b = bytes[pos++]; value += (b & 127) * factor;
      if (!(b & 128)) return value;
      factor *= 128;
    }
    throw new Error('invalid coordinate');
  }
  const signed = n => n % 2 ? -(n + 1) / 2 : n / 2;
  const sites = [], names = new Map();
  // One array per connector mask: identical arrays are cloned once per message, not once per charge point.
  const connectors = mask => { let a = names.get(mask); if (!a) names.set(mask, a = CONNECTORS.filter((_, bit) => mask & (1 << bit))); return a; };
  for (let i = 0; i < count; i++) {
    x += signed(read()); y += signed(read()); const id = code(read());
    if (pos + 3 > bytes.length) throw new Error('incomplete site');
    const mask = bytes[pos++], ac = kw(bytes[pos++]), dc = kw(bytes[pos++]);
    const points = [];
    if (bytes[4] >= 2) {
      const size = read();
      for (let j = 0; j < size; j++) {
        if (pos + (bytes[4] === 3 ? 6 : 5) > bytes.length) throw new Error('incomplete charge point');
        const plug = bytes[pos++], power = Math.round(view.getFloat32(pos, true) * 1e6) / 1e6; pos += 4;
        const current = bytes[4] === 3 ? [null, 'AC', 'DC'][bytes[pos++]] ?? null : null;
        points.push({...(bytes[4] === 3 ? {current} : {}), index: index++, mask: plug, kw: power, connectors: connectors(plug), status: 'unknown'});
      }
    }
    sites.push({id, lon: x / 8192, lat: y / 8192, mask, ac, dc, ...(version ? {points} : {})});
  }
  if (pos !== bytes.length) throw new Error('unexpected trailing bytes');
  sites.version = version;
  return sites;
}
